module.exports = __webpack_public_path__ + "img/cs-basePar-1.b1ba7ab1.jpg";